"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _Card = _interopRequireDefault(require("./Card.styles"));

var Card = /*#__PURE__*/(0, _react.forwardRef)(function Card(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      restOfProps = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  var classes = (0, _Card.default)();
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, restOfProps, {
    className: (0, _classnames.default)('pds-card', classes.root, className),
    ref: ref
  }), children);
});
Card.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node,

  /**
   * The CSS class name to apply to the card node.
   */
  className: _propTypes.string
};
var _default = Card;
exports.default = _default;
